import React, { Component } from "react";
import { Redirect } from "react-router-dom";

export default class ProjectDetails extends Component {
  state = {};
  componentWillMount() {
    const { match } = this.props,
      project_name = match.params.name;
    let project;
    try {
      project = require(`../Projects/${project_name}`);
      this.setState(prevState => {
        return { ProjectComponent: project[project_name] };
      });
    } catch (e) {
      console.log("Error occured", e);
    }
  }
  render() {
    const { ProjectComponent } = this.state;
    if (!ProjectComponent) return <Redirect push to={`/`} />;
    return <ProjectComponent />;
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectDetails.js